import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectGlobalServiceTypesQueryItems } from '../../../../../redux/global-iship-cloud/global-service-types/selector';
import PageLoader from '../../../../../components/PageLoader';
import GlobalServiceTypesComponent from '../components/global-service-types.component';
import { globalServiceTypes } from '../../../../../redux/global-iship-cloud/global-service-types/action';

let currentChange: any = {}
const GlobalServiceType = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectGlobalServiceTypesQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    serviceType,
    setServiceType
  ] = useState<any>({})

  const fetchRecordById = () => {
    dispatch(globalServiceTypes.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-service-types/fetch-detail`, entity: 'globalServiceTypes', jsonData:
      {
        Context: {},
        Records: [
          {
            "GlobalServiceTypeId": parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchRecordById()
      }
    }, [])

  useEffect(
    () => {
      if (isQuery) {
        setServiceType(queryItems?.result?.items)
      }
    }, [isQuery])

  const handleInnerBasicFormChange: any = (event: any, field: string) => {
    setServiceType({ ...serviceType, [field]: event });
  }

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();

    if (parmas?.id > 0) {
      dispatch(globalServiceTypes.update({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-service-types`, entity: 'globalServiceTypes', jsonData:
        {
          "Context": {},
          Records: [
            serviceType
          ]
        }
      })).then(() => {
        back()
      })
    } else {
      dispatch(globalServiceTypes.create({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/global-iship-cloud/global-service-types`, entity: 'globalServiceTypes', jsonData:
        {
          "Context": {
          },
          Records: [
            serviceType
          ]
        }
      })).then(() => {
        back()
      })
    }
  }

  const back = async () => {
    navigate(-1)
  }

  return (
    <>
      {queryItems?.isLoading ? <PageLoader /> :
        <GlobalServiceTypesComponent
          serviceType={serviceType}
          handleFormSubmit={handleFormSubmit}
          back={back}
          handleInnerBasicFormChange={handleInnerBasicFormChange}
        />}
    </>
  )

}

export default GlobalServiceType;